import { SVGProps } from "react";

export function UpdateRefreshIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 10.9997C19.7554 9.23992 18.9391 7.60937 17.6766 6.3592C16.4142 5.10904 14.7758 4.30862 13.0137 4.08126C11.2516 3.85389 9.46362 4.21219 7.9252 5.10095C6.38678 5.98972 5.18325 7.35964 4.5 8.99971M4 4.99971V8.99971H8M4 12.9997C4.24456 14.7595 5.06093 16.39 6.32336 17.6402C7.58579 18.8904 9.22424 19.6908 10.9863 19.9182C12.7484 20.1455 14.5364 19.7872 16.0748 18.8985C17.6132 18.0097 18.8168 16.6398 19.5 14.9997M20 18.9997V14.9997H16"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
